// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kg-0";
export var fileCarousel = "_kg-2";
export var removeFileButton = "_kg-1";